import { Reducer } from '../../reducers';
import { connect } from 'react-redux';

interface LogoProps {
  logoPath: string;
}

class Logo extends React.PureComponent<LogoProps> {
  render() {
    const { logoPath } = this.props;

    return (
      <div className="Client-Logo">
        <img src={`${window.Edocat.texts.appContext}${logoPath}`} alt="Client Logo" />
      </div>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  logoPath: state.login.logoPath,
});

export default connect(mapStateToProps, null)(Logo);
